$('.styledWysiwyg table').wrap('<div class="table-wrapper"></div>');